import { Avatar, IconButton } from '@schuettflix/react-components';
import { DeleteIcon } from '@schuettflix/icons-react';
import { useTranslation } from 'react-i18next';
import { ContactPerson } from '@/modules/location/domain/ContactPersonSchema.ts';
import { cn } from '@/shared/utils/cn';
import { CONTACT_PERSON_ROLES_LABEL } from '@/modules/location/components/roleselector/Roles.ts';

interface ContactCardProps {
    value: ContactPerson;
    onDelete: () => void;
    onClick?: () => void;
}

export const ContactCard = (props: ContactCardProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'card card--rounded card--action flex items-center gap-4',
                props.onClick ? 'card--focussed' : 'cursor-default'
            )}
            onClick={props.onClick}
            tabIndex={props.onClick ? 0 : undefined}
            role={props.onClick ? 'button' : undefined}
            onKeyDown={event => {
                if (!props.onClick || event.key !== 'Enter') return;
                event.preventDefault();
                props.onClick();
            }}
            onKeyUp={event => {
                if (!props.onClick || event.key !== ' ') return;
                event.preventDefault();
                props.onClick();
            }}
        >
            <Avatar />
            <div className="min-w-0 flex-1 space-y-1">
                <div className="font-copy-md-strong">{props.value.name}</div>
                <ul className="flex items-center gap-2">
                    <li className="font-copy-sm truncate">{t(CONTACT_PERSON_ROLES_LABEL[props.value.role.value])}</li>
                    <li className="font-copy-sm divide-rounded-sm whitespace-nowrap">
                        {props.value.phone.countryCode.code}
                        {props.value.phone.number}
                    </li>
                </ul>
            </div>
            <IconButton
                type="button"
                icon={DeleteIcon}
                onClick={event => {
                    event.stopPropagation();
                    props.onDelete();
                }}
            />
        </div>
    );
};
